import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import './WebScraper.scss';

interface ArgosTask {
  country: string;
  taskNumber: string;
}

interface Incident {
  incidentNumber?: string;
  status?: string;
  argosTaskNumbers?: ArgosTask[];
}

const IncidentStatusChip = ({
  incident,
  onClick,
  size = 'small',
}: {
  incident?: Incident;
  onClick?: () => void;
  size?: 'small' | 'medium';
}) => {
  if (!incident || !incident.incidentNumber) {
    return null;
  }

  const getChipColor = (): 'primary' | 'info' | 'warning' | 'success' | 'default' => {
    switch (incident.status) {
      case 'New':
        return 'primary';
      case 'In Progress':
        return 'info';
      case 'On Hold':
        return 'warning';
      case 'Resolved':
      case 'Closed':
        return 'success';
      case 'Canceled':
        return 'default';
      default:
        return 'default';
    }
  };

  const tooltipContent = incident.argosTaskNumbers
    ? `Argos Tasks: ${incident.argosTaskNumbers.map((t: ArgosTask) => `${t.country}: ${t.taskNumber}`).join(', ')}`
    : `Status: ${incident.status}`;

  return (
    <Tooltip title={tooltipContent} arrow>
      <Chip
        label={incident.incidentNumber}
        color={getChipColor()}
        size={size}
        onClick={onClick}
        clickable={!!onClick}
        className="ws-incident-chip"
      />
    </Tooltip>
  );
};

export default IncidentStatusChip;
